/**
 * Preserves search params (search, startDate, endDate, itemsPerPage) when updating pagination
 */
export const preserveSearchParams = (
  searchParams: URLSearchParams,
  additionalParams: Record<string, string>
): Record<string, string> => {
  const params: Record<string, string> = { ...additionalParams };

  if (!("search" in additionalParams)) {
    const currentSearch = searchParams.get("search");
    if (currentSearch) params.search = currentSearch;
  }

  if (!("startDate" in additionalParams)) {
    const startDate = searchParams.get("startDate");
    if (startDate) params.startDate = startDate;
  }
  if (!("endDate" in additionalParams)) {
    const endDate = searchParams.get("endDate");
    if (endDate) params.endDate = endDate;
  }

  if (!("itemsPerPage" in additionalParams)) {
    const itemsPerPage = searchParams.get("itemsPerPage");
    if (itemsPerPage) params.itemsPerPage = itemsPerPage;
  }

  return params;
};

/**
 * Button style constants for RidesList
 */
export const BUTTON_STYLES = {
  UPDATE_ITEMS: {
    normal: {
      backgroundColor: "rgb(0, 178, 163)",
      color: "rgb(255, 255, 255)",
      border: "1px solid rgb(0, 178, 163)"
    },
    hover: {
      backgroundColor: "rgb(0, 150, 138)",
      border: "1px solid rgb(0, 178, 163)"
    },
    disabled: {
      color: "rgb(255, 255, 255)",
      backgroundColor: "rgb(149, 158, 178)",
      border: "1px solid rgb(149, 158, 178)"
    }
  },
  CANCEL: {
    normal: {
      backgroundColor: "#fff",
      color: "rgb(0, 178, 163)",
      border: "1px solid rgb(0, 178, 163)"
    },
    hover: {
      backgroundColor: "#fff",
      color: "rgb(0, 178, 163)",
      border: "1px solid rgb(0, 178, 163)"
    },
    disabled: {
      color: "rgb(149, 158, 178)",
      backgroundColor: "rgb(255, 255, 255)",
      border: "1px solid rgb(149, 158, 178)"
    }
  }
};
